import React from 'react'
import styles from '../styles/arrow.module.css';


function DownArrow() {
  return (
    <div className={styles.downarrow}></div>
  )
}

export default DownArrow